"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useImage_unstable", {
    enumerable: true,
    get: ()=>useImage_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const useImage_unstable = (props, ref)=>{
    const { bordered =false , fit ='default' , block =false , shape ='square' , shadow =false  } = props;
    const state = {
        bordered,
        fit,
        block,
        shape,
        shadow,
        components: {
            root: 'img'
        },
        root: (0, _reactUtilities.getNativeElementProps)('img', {
            ref,
            ...props
        })
    };
    return state;
}; //# sourceMappingURL=useImage.js.map

//# sourceMappingURL=useImage.js.map